module.exports = __webpack_public_path__ + "static/media/stanford.d2618e48.jpg";